import { render, staticRenderFns } from "./IconHome.vue?vue&type=template&id=5ba04f44&scoped=true"
import script from "./IconHome.vue?vue&type=script&lang=js"
export * from "./IconHome.vue?vue&type=script&lang=js"
import style0 from "./IconHome.vue?vue&type=style&index=0&id=5ba04f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba04f44",
  null
  
)

export default component.exports